module.exports = __webpack_public_path__ + "build/desktop/a/img/checkbox.ddb87e5682dbdcd69ca4e49ae086bf0b.svg";